/* eslint-disable react/jsx-boolean-value */
import React, { useState } from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { SvgIcon } from "@material-ui/core";
import "./style.css"

const MenuIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <rect x="9" y="6.5" width="11" height="1" />
      <rect x="4" y="6" width="3" height="2" />
      <rect x="9" y="11.5" width="11" height="1" />
      <rect x="4" y="11" width="3" height="2" />
      <rect x="9" y="16.5" width="11" height="1" />
      <rect x="4" y="16" width="3" height="2" />
    </SvgIcon>
  );
};

const CalendarTodayIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M4.5 9.5H19.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 6.5H5.5C5.23478 6.5 4.98043 6.60536 4.79289 6.79289C4.60536 6.98043 4.5 7.23478 4.5 7.5V18.5C4.5 18.7652 4.60536 19.0196 4.79289 19.2071C4.98043 19.3946 5.23478 19.5 5.5 19.5H18.5C18.7652 19.5 19.0196 19.3946 19.2071 19.2071C19.3946 19.0196 19.5 18.7652 19.5 18.5V7.5C19.5 7.23478 19.3946 6.98043 19.2071 6.79289C19.0196 6.60536 18.7652 6.5 18.5 6.5V6.5Z"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 4.5V6.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 4.5V6.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

const useStyles = makeStyles(() => ({
  filtersContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  filterColumn: {
    display: 'flex',
    alignItems: 'center',
    width: "90%",
    overflow: "auto",
  },
  root: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    margin: 4,
    backgroundColor: '#fff',
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: '0.4px',
    '&:focus': {
      backgroundColor: '#fff',
    },
  },
  rootlabel: {
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: '0.25px',
    marginRight: 10,
  },
  toggleEventViews: {
    display: 'flex',
    border: '1px solid #eee',
    alignItems: 'center',
  },
  menuIconWrapper: {
    padding: 4,
    backgroundColor: (props) => props.listView ? "rgba(38, 167, 237, 10%)" : "#FFF"
  },
  calendarIconWrapper: {
    padding: 4,
    backgroundColor: (props) => !props.listView ? "rgba(38, 167, 237, 10%)" : "#FFF"
  },
  menuicon: {
    width: 24,
    height: 24,
    fill: (props) => (props.listView ? '#26BBED' : '#999'),
    '&:hover': {
      cursor: 'pointer',
      fill: '#26BBED'
    },
  },
  calendericon: {
    width: 24,
    height: 24,
    fill: "none",
    stroke: (props) => (props.listView ? '#999' : '#26BBED'),
    '&:hover': {
      cursor: 'pointer',
      stroke: '#26BBED'
    },
  },
  clearFilters: {
    padding: 8,
    margin: 4,
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: '0.4px',
    color: "#4F6FAE",
    cursor: "pointer",
  }
}));
const EventFilters = ({
  onLabelClickedCallback,
  onViewChangedClickedCallback,
  filters,
  chosenStatus
}) => {
  const [selectedFilters, setSelectedFilters] = useState(chosenStatus);
  const [listView, setListView] = useState(true);

  const classes = useStyles({ listView });

  const onLabelClicked = (value) => {
    let allSelectedFilters = [...selectedFilters];
    if (selectedFilters.find((selectedfilters) => selectedfilters === value))
      allSelectedFilters = allSelectedFilters.filter((selectedfilter) => value !== selectedfilter);
    else allSelectedFilters.push(value);

    setSelectedFilters(allSelectedFilters);
    if (onLabelClickedCallback) onLabelClickedCallback(allSelectedFilters);
  };

  const handleClearClick = () => {
    setSelectedFilters([]);
    if (onLabelClickedCallback)
      onLabelClickedCallback(
        []
      );
  }

  const onViewChanged = () => {
    setListView(!listView);
    if (onViewChangedClickedCallback) onViewChangedClickedCallback(!listView);
  };

  return (
    <div className={classes.filtersContainer}>
      <div className={classes.filterColumn}>
        <Typography className={classes.rootlabel}>Filter By: </Typography>
        {filters.map((filter) => (
          <Chip
            key={filter.label}
            className={classes.root}
            style={
              selectedFilters.find((selectedfilters) => selectedfilters === filter.value)
                ? {
                  color: filter.selectedColor,
                  borderColor: filter.selectedColor,
                }
                : { color: '#999', borderColor: '#eee' }
            }
            size='small'
            label={filter.label}
            onClick={onLabelClicked.bind(this, filter.value)}
            variant='outlined'
            clickable={true}
          />
        ))}
        {
          selectedFilters.length > 0 ? <div className={classes.clearFilters} onClick={handleClearClick}>Clear all</div> : null
        }

      </div>
      <div className={classes.toggleEventViews}>
        <div className={classes.menuIconWrapper}>
          <MenuIcon
            className={classes.menuicon}
            onClick={onViewChanged}
          />
        </div>
        <div className={classes.calendarIconWrapper}>
          <CalendarTodayIcon
            className={classes.calendericon}
            onClick={onViewChanged}
          />
        </div>
      </div>
    </div>
  );
};

EventFilters.propTypes = {
  /**
   * Listener Function that will listen for selecter filters changed and consume selected filters as arrays
   */
  onLabelClickedCallback: PropTypes.func.isRequired,
  /**
   * Listener Function that will listen if view is changed from listview to calender view
   * true=listview , false = calenderview
   */
  onViewChangedClickedCallback: PropTypes.func.isRequired,

  /**
   *   array of filters and their colors
   */
  // eslint-disable-next-line react/forbid-prop-types
  filters: PropTypes.array,
};

EventFilters.defaultProps = {
  filters: [],
};

export default EventFilters;
